/** See `src/i18n/locales/en/manageSupport.ts`. */
export const manageSupport = {
  page: {
    title: 'Supporto',
    lead: 'Tutti i ticket di supporto della piattaforma, filtrabili per stato e priorità.',
    filterStatus: 'Stato',
    filterPriority: 'Priorità',
    allStatuses: 'Tutti gli stati',
    allPriorities: 'Tutte le priorità',
    empty: 'Nessun ticket corrisponde a questi filtri.',
    rowsLabel: 'i ticket',
    subject: 'Oggetto',
    company: 'Azienda',
    status: 'Stato',
    priority: 'Priorità',
    createdAt: 'Aperto',
  },
  status: {
    open: 'Aperto',
    in_progress: 'In corso',
    resolved: 'Risolto',
    closed: 'Chiuso',
  },
  priority: {
    low: 'Bassa',
    normal: 'Normale',
    high: 'Alta',
    urgent: 'Urgente',
  },
  detail: {
    thisTicket: 'questo ticket',
    requesterTitle: 'Richiedente',
    requesterLabel: 'il richiedente',
    controlsTitle: 'Stato e priorità',
    save: 'Salva',
    threadTitle: 'Conversazione',
    threadEmpty: 'Nessun messaggio ancora.',
    replyLabel: 'Risposta',
    reply: 'Invia risposta',
  },
} as const;
